<template>

  <div class="content-card col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3">
    <div class="row">
      <div class="content-card__title">
        <slot name="title"/>
      </div>
    </div>
    <div class="row">
      <p class="content-card__content">
        <slot name="content"/>
      </p>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'ContentCard'
}
</script>

<style lang="scss">

.content-card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  background-color: #fff;


  &__title {
    font-size: 19px;
    text-align: center;
    padding: 15px 0;
    font-weight: 600;
    border-bottom: 1px solid #e7e7e7;
  }

  &__content {
    padding: 9px 15px;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    min-height: 115px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/content/ContentCard.vue